<script setup lang="ts">
import { vElementVisibility } from '@vueuse/components'
import LanguageView from '@/core/components/LanguageView.vue'
import { baseUrl, padWithZeros } from '@/core/utils'
import { SAMUDKOY } from '../../constants'
import { usePopupTranslate } from './PopupTranslate'

const { currentPage, show, updateCurrentPage } = usePopupTranslate()

function handleElementVisibility(state: boolean) {
  if (state) {
    updateCurrentPage()
  }
}
</script>

<template>
  <transition name="fade" mode="out-in">
    <div v-show="show" class="popup-translate" v-element-visibility="handleElementVisibility">
      <LanguageView lang="th">
        <template v-for="page in SAMUDKOY.TRANSLATE_TH_PAGES">
          <img
            v-show="page == currentPage"
            class="page"
            :src="baseUrl(`/images/samudkoy-popup/th/${padWithZeros(page, 2)}.png`)"
          />
        </template>
      </LanguageView>
      <LanguageView lang="en">
        <template v-for="page in SAMUDKOY.TRANSLATE_EN_PAGES">
          <img
            v-show="page == currentPage"
            class="page"
            :src="baseUrl(`/images/samudkoy-popup/en/${padWithZeros(page, 2)}.png`)"
          />
        </template>
      </LanguageView>
    </div>
  </transition>
</template>

<style scoped>
/* ---------------------------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
/* ---------------------------- */
.fade-in-enter-active {
  transition: opacity 0.5s ease;
}

.fade-in-leave-active {
  opacity: 0;
  animation-duration: 0ms;
  transition: none !important;
}

.fade-in-enter-from,
.fade-in-leave-to {
  opacity: 0;
}

/* ---------------------------- */
.popup-translate {
  position: absolute;
  top: 36px;
  left: 30px;
  width: 1350px;
  height: 970px;
  /* border: 1px solid #0f0; */
}

.page {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
